module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.backgroundTransitionHome,
    attrs: {
      "id": "mainDiv"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated pulse",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWelcomePage),
      expression: "showWelcomePage"
    }],
    key: "navBar",
    staticClass: "col-xs-12 text-center",
    attrs: {
      "id": "optionsBucket"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('span', [(_vm.initSpeech) ? _c('button', {
    class: _vm.speechStartStop,
    attrs: {
      "id": "welcomeBtnVoice"
    },
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.aboutHideTxtGen),
      expression: "!aboutHideTxtGen"
    }],
    attrs: {
      "id": "clickedAbout"
    }
  }, [_vm._v(" Click To Use Voice Commands ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutHideTxtGen),
      expression: "aboutHideTxtGen"
    }]
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('button', {
    class: _vm.speechStartStop,
    attrs: {
      "id": "welcomeBtnVoice"
    },
    on: {
      "click": _vm.stopSpeech
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.aboutHideTxtGen),
      expression: "!aboutHideTxtGen"
    }],
    attrs: {
      "id": "clickedAbout"
    }
  }, [_c('i', {
    class: _vm.speechIconClass
  }), _vm._v(" " + _vm._s(_vm.speechBtnTxt) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutHideTxtGen),
      expression: "aboutHideTxtGen"
    }]
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.aboutBtnClass,
    attrs: {
      "id": "welcomeBtnAbout"
    },
    on: {
      "click": _vm.goToAbout
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.aboutHideTxtGen),
      expression: "!aboutHideTxtGen"
    }],
    attrs: {
      "id": "clickedAbout"
    }
  }, [_vm._v(" " + _vm._s(_vm.aboutTxt) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutHideTxtGen),
      expression: "aboutHideTxtGen"
    }]
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnPlains,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToPlains
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedPlains"
    }
  }, [_vm._v(_vm._s(_vm.plainsTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnOcean,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToOcean
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedOcean"
    }
  }, [_vm._v(_vm._s(_vm.oceanTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnAmazon,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToAmazon
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedAmazon"
    }
  }, [_vm._v(_vm._s(_vm.amazonTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnForest,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToForest
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedForest"
    }
  }, [_vm._v(_vm._s(_vm.forestTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnDesert,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToDesert
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedDesert"
    }
  }, [_vm._v(_vm._s(_vm.desertTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnBeach,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToBeach
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedBeach"
    }
  }, [_vm._v(_vm._s(_vm.beachTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnMetro,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToNYC
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedNYC"
    }
  }, [_vm._v(_vm._s(_vm.nycTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnRural,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToRural
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedRural"
    }
  }, [_vm._v(_vm._s(_vm.ruralTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnFire,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goTofire
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedFire"
    }
  }, [_vm._v(_vm._s(_vm.fireTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnIce,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToice
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedIce"
    }
  }, [_vm._v(_vm._s(_vm.iceTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnTut,
    attrs: {
      "id": "welcomeBtnAbout"
    },
    on: {
      "click": _vm.goToTut
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedTut"
    }
  }, [_vm._v(_vm._s(_vm.tutTxt))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12 text-center",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "far fa-headphones"
  }), _vm._v(" \n\t\t\t\t\t\t\tHeadphones Recommended \n\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "far fa-headphones"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v("  \n\n\t\t\t\t\t\tEnter this immersive audio experience and explore unique soundscapes from around the world. "), _c('span', {
    attrs: {
      "id": "lineBreak"
    }
  }, [_vm._v("Within each soundscape, control individual sounds to create the sonic shape of a greater soundscape.")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "lineBreak"
    }
  }, [_vm._v("Use digital audio effects to shape your soundscapes further by twisting and transforming their sound waves.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }]
  }, [_vm._v(" \n\t\t\t\t\t\t\tEars never blink, we're always listening.\n\t\t\t\t\t\t\t"), _c('br')])]), _vm._v(" "), _c('button', {
    class: _vm.aboutVOClass,
    attrs: {
      "id": "aboutSectionVO"
    },
    on: {
      "click": _vm.aboutVOFunc
    }
  }, [_c('i', {
    class: _vm.aboutVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\tAbout This Project\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('strong', [_vm._v("\n\t\t\t\t\t\tCreated & Built by  \n\t\t\t\t\t\t\t"), _c('a', {
    style: ({
      'color': _vm.aboutVOBoolean ? 'green' : 'red'
    }),
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tMatt McCorkle\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "shoutOut"
    }
  }, [_vm._v("\n\t\t\t\t\t\tUtilizing the \n\t\t\t\t\t\t\t"), _c('strong', [_c('a', {
    style: ({
      'color': _vm.aboutVOBoolean ? 'green' : 'red'
    }),
    attrs: {
      "href": "https://tonejs.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tTone.js\n\t\t\t\t\t\t\t\t")])]), _vm._v("\n\t\t\t\t\t\t\tWeb Audio Framework\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "mailingListText"
    }
  }, [_vm._v(" \n\t\t\t\t\t\tStay in touch for new soundscape releases! \n\t\t\t\t\t\t"), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&id=219d3ce36c",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('input', {
    staticClass: "email",
    staticStyle: {
      "border-color": "black",
      "color": "black"
    },
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px",
      "color": "black"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_cc407290614bbaa2daa32fe9e_219d3ce36c",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticStyle: {
      "border-color": "black",
      "color": "black"
    },
    attrs: {
      "type": "submit",
      "value": "Subscribe!",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 Matt McCorkle\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t"), _c('br')]), _vm._v(" "), _c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close fa-3x",
    attrs: {
      "aria": "true"
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9f3f402","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome.vue
// module id = 70
// module chunks = 0